<div>
  <form [formGroup]="firstFormGroup">
    <mat-form-field appearance="outline"
                    class="input-events">
      <mat-label>Titulo</mat-label>
      <input matInput
             formControlName="title"
             required />
      <mat-error *ngIf="firstFormGroup.get('title')?.hasError('required')">
        Informe o título
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline"
                    class="input-events">
      <mat-label>Descrição</mat-label>
      <textarea matInput
                formControlName="description"
                required></textarea>
      <mat-error *ngIf="firstFormGroup.get('description')?.hasError('required')">Informe a descrição</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline"
                    class="input-events">
      <mat-label>Local</mat-label>
      <input matInput
             formControlName="place"
             required />
      <mat-error *ngIf="firstFormGroup.get('place')?.hasError('required')">
        Informe o local
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline"
                    class="input-form date">
      <mat-label>Data Início</mat-label>
      <input matInput
             readonly
             [ngxMatDatetimePicker]="picker"
             formControlName="startDate"
             (focus)="picker.open()"
             [min]="minDate"
             required />
      <mat-datepicker-toggle matSuffix
                             [for]="$any(picker)">
      </mat-datepicker-toggle>
      <ngx-mat-datetime-picker #picker
                               [hideTime]="false">
      </ngx-mat-datetime-picker>
      <mat-error *ngIf="firstFormGroup.get('startDate')?.hasError('matDatetimePickerMin')">
        Data de início deve ser maior que a atual
      </mat-error>
      <mat-error *ngIf="firstFormGroup.get('startDate')?.hasError('required')">
        Informe a data de início
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline"
                    class="input-form date">
      <mat-label>Data de Término</mat-label>
      <input matInput
             readonly
             [ngxMatDatetimePicker]="picker2"
             formControlName="endDate"
             (focus)="picker2.open()"
             [min]="firstFormGroup.controls['startDate'].value"
             required />
      <mat-datepicker-toggle matSuffix
                             [for]="$any(picker2)">
      </mat-datepicker-toggle>
      <ngx-mat-datetime-picker #picker2
                               [hideTime]="false">
      </ngx-mat-datetime-picker>
      <mat-error *ngIf="firstFormGroup.get('endDate')?.hasError('matDatetimePickerMin')">
        Data de término deve ser maior que a data início
      </mat-error>
      <mat-error *ngIf="firstFormGroup.get('endDate')?.hasError('required')">
        Informe a data de término
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline"
                    class="input-form date">
      <mat-label>Data Limite para Realizar Reserva</mat-label>
      <input matInput
             readonly
             [ngxMatDatetimePicker]="picker3"
             formControlName="deadlineDate"
             (focus)="picker3.open()"
             [max]="firstFormGroup.controls['startDate'].value"
             required />
      <mat-datepicker-toggle matSuffix
                             [for]="$any(picker3)">
      </mat-datepicker-toggle>
      <ngx-mat-datetime-picker #picker3
                               [hideTime]="false">
      </ngx-mat-datetime-picker>
      <mat-error *ngIf="firstFormGroup.get('deadlineDate')?.hasError('matDatetimePickerMax')">
        Data de limite para realizar de reserva deve ser menor que a data de início
      </mat-error>
      <mat-error *ngIf="firstFormGroup.get('deadlineDate')?.hasError('required')">
        Informe a data limite para realizar de reserva
      </mat-error>
    </mat-form-field>
    <br />
    <mat-card appearance="outlined">
      <mat-card-title>
        <p class="title-card">Capa do evento (opcional)</p>
      </mat-card-title>
      <mat-card-content>
        <div id="capa-anexo">
          <div class="container-capa"   [ngClass]="{'disabled': firstFormGroup.disabled}">
            <p class="title-tamanho-imagem">
              Dimensão recomendada da capa: 450px de largura por 150px de altura.
            </p>
            <p>Tamanho máximo permitido da imagem: 10MB.</p>
            <app-file-uploader [text]="'Adicionar imagem de capa'"
                               [type]="'background'"
                               [initialFiles]="bgFiles"
                               [disabled]="firstFormGroup.disabled"
                               (currentFilesEmitter)="onCurrentAttachmentsEmit($event)">
            </app-file-uploader>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <br />
  </form>
</div>
